<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/inventory/stocktransfer" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("inventory.label.ViewItemDetail") }}</h3>
          </li>
        </ul>
      </div>
      <div class="w-full">
        <vx-card title no-shadow card-border>
          <div class="block overflow-x-auto">
            <vs-table stripe :data="item">
              <template slot-scope="{ data }">
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.Office") }}</b></vs-td
                  >
                  <vs-td>{{ item.officeName }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.ItemDescription") }}</b></vs-td
                  >
                  <vs-td>{{ item.itemDescription }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.SerialNo ") }}</b></vs-td
                  >
                  <vs-td>{{ item.serialNumber }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.GrnId") }}</b></vs-td
                  >
                  <vs-td>
                    {{ item.grnId }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.SupplierCode") }}</b></vs-td
                  >
                  <vs-td>
                    {{ item.supplier }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.Quality") }}</b></vs-td
                  >
                  <vs-td>
                    {{ item.quality }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.Status") }}</b></vs-td
                  >
                  <vs-td>
                    {{ item.status }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td
                    ><b>{{ $t("inventory.label.Warranty") }}</b></vs-td
                  >
                  <vs-td>
                    {{ item.warranty }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { getByViewItemDetails } from "@/http/inventory/";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      item: {},
      items: [],
      purchaseDate: [],
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },

    async getByViewItemDetails() {
      try {
        const response = await getByViewItemDetails(this.id);
        this.item = response.data;
        //   this.fee.feeCode = response.data.feeMasterData.feeCode;
        //   this.fee.transactionType = response.data.feeMasterData.transactionType;
        //   this.fee.chargeCode = response.data.feeMasterData.chargeCode;
        //   this.fee.feeDescription = response.data.feeMasterData.feeDescription;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving job by id:",
          error
        );
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getByViewItemDetails();
  },
  watch: {},
};
</script>
<style lang="less" scoped></style>
